import React from "react";
import { useSettings } from "../lib/SettingsContext";

// Converts "0755 680 215" or "+40 755 680 215" to "40755680215" for wa.me
const cleanPhone = (raw) => {
  if (!raw) return "";
  const digits = raw.replace(/\D/g, "");
  if (digits.startsWith("40")) return digits;
  if (digits.startsWith("0")) return "40" + digits.slice(1);
  return digits;
};

export default function WhatsAppWidget({ productId }) {
  const { settings } = useSettings();
  const phoneRaw = settings.whatsapp_phone || settings.contact_phone || "0755680215";
  const phone = cleanPhone(phoneRaw);
  if (!phone) return null;

  const brand = settings.brand_name || "Johny's Antique Shop";
  const productLink = typeof window !== "undefined" && productId ? `${window.location.origin}/products/${productId}` : "";
  const message = productId
    ? `Bună! Sunt interesat de o piesă de la ${brand}: ${productLink}`
    : `Bună! Aș vrea mai multe informații despre piesele de la ${brand}.`;

  const href = `https://wa.me/${phone}?text=${encodeURIComponent(message)}`;

  return (
    <a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      aria-label="WhatsApp"
      title="Discută pe WhatsApp"
      data-testid="whatsapp-button"
      className="fixed bottom-6 right-6 z-[60] w-14 h-14 rounded-full flex items-center justify-center shadow-[0_10px_40px_rgba(37,211,102,0.45)] hover:scale-110 transition-transform"
      style={{ background: "#25D366" }}
    >
      <svg viewBox="0 0 32 32" width="26" height="26" fill="#ffffff" aria-hidden="true">
        <path d="M19.11 17.205c-.372 0-1.088 1.39-1.518 1.39a.63.63 0 0 1-.315-.1c-.802-.402-1.504-.817-2.163-1.447-.545-.516-1.146-1.29-1.46-1.963a.426.426 0 0 1-.073-.215c0-.33.99-.945.99-1.49 0-.143-.73-2.09-.832-2.335-.143-.372-.214-.487-.6-.487-.187 0-.36-.043-.53-.043-.302 0-.53.115-.746.315-.688.645-1.032 1.318-1.06 2.264v.114c-.015.99.472 1.977 1.017 2.78 1.23 1.82 2.506 3.41 4.554 4.34.616.287 2.035.888 2.722.888.817 0 2.15-.515 2.507-1.318.216-.487.216-.9.144-.99-.058-.144-.302-.216-.66-.373zM16.253 4C9.494 4 4 9.494 4 16.253c0 2.336.658 4.66 1.91 6.638L4 30l7.324-1.898a12.313 12.313 0 0 0 4.917 1.008h.013C22.988 29.11 28.5 23.61 28.5 16.85 28.5 10.09 22.996 4 16.253 4zm0 22.596h-.014c-1.635 0-3.264-.423-4.712-1.234l-.331-.201-4.203 1.098 1.117-4.11-.216-.331a10.32 10.32 0 0 1-1.577-5.484c0-5.7 4.611-10.323 10.31-10.323a10.34 10.34 0 0 1 10.311 10.323c0 5.7-4.629 10.262-10.685 10.262z"/>
      </svg>
    </a>
  );
}
